// extracted by mini-css-extract-plugin
export default {"clusterIcon":"Map_clusterIcon__vbzAo"};